import React, { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useWebSocket } from '../hooks/useWebSocket';

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
    useLocation(); // Re-read authentication after login/logout navigation.
    const token = localStorage.getItem('token');
    const socketState = useWebSocket({ token });

    return (
        <WebSocketContext.Provider value={socketState}>
            {children}
        </WebSocketContext.Provider>
    );
};

export const useSocket = () => useContext(WebSocketContext);
